import validate from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@8.0.7__@babel+plugin-syntax-type_56b9151aa37c35c4ce09a6c9b47bda79/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/Users/wouter/prjs/wouter/krewebacchus/middleware/01-auth.global.ts";
import manifest_45route_45rule from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@8.0.7__@babel+plugin-syntax-type_56b9151aa37c35c4ce09a6c9b47bda79/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}